import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { Amplify } from 'aws-amplify';
import { AMPLIFY_CONFIG } from './app/core/config/amplify.config';
import { authInterceptor } from './app/core/interceptors/auth.interceptor';
import { tokenInterceptor } from './app/core/interceptors/token.interceptor';
import { environment } from './environments/environment';

// Desactivar console.log en producción
if (environment.production && typeof window !== 'undefined') {
  window.console.log = () => {};
  window.console.debug = () => {};
  window.console.info = () => {};
  // Mantener console.warn y console.error activos para debugging crítico
}

// Configurar AWS Amplify solo en el navegador (no en SSR)
if (typeof window !== 'undefined') {
  console.log('🔧 Configurando Amplify antes del bootstrap...');
  Amplify.configure(AMPLIFY_CONFIG, { ssr: false });
  console.log('✅ Amplify configurado correctamente');
  
  // Verificar que la configuración fue aplicada
  try {
    /* const config = Amplify.getConfig();
    console.log('📋 Configuración verificada:', {
      hasAPI: !!config.API,
      hasGraphQL: !!config.API?.GraphQL,
      endpoint: config.API?.GraphQL?.endpoint
    }); */
  } catch (error) {
    console.error('❌ Error verificando configuración:', error);
  }
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([tokenInterceptor, authInterceptor])),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
  ],
});
